var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 37,
    viewBox: "0 0 26 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 36.6805C10.3287 36.6803 7.88175 35.9276 5.80992 34.52C3.73809 33.1124 2.13691 31.1149 1.21399 28.7864C0.29106 26.4579 0.0889564 23.9058 0.63388 21.461C1.1788 19.0163 2.44562 16.7916 4.27008 15.0755C6.50674 12.9705 12.0001 9.1805 11.1667 0.847168C21.1667 7.51383 26.1667 14.1805 16.1667 24.1805C17.8334 24.1805 20.3334 24.1805 24.5001 20.0638C24.9501 21.3522 25.3334 22.7372 25.3334 24.1805C25.3334 27.4957 24.0164 30.6751 21.6722 33.0193C19.328 35.3635 16.1486 36.6805 12.8334 36.6805Z",
    fill: "#D2464F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.c7da45eec480ad2eb61fe6c665ef6607.svg";
export { ForwardRef as ReactComponent };